/**
 * Mock reminders for dev / mock-mode. Linked to seeded mock customers
 * (`cust-001`..`cust-003`) via `entityType: 'individual_customer'` so the
 * customer Reminders tab has upcoming + overdue data.
 *
 * Dates are computed relative to "now" so the upcoming/overdue split stays
 * meaningful regardless of when the mock is loaded.
 */

import type { Reminder } from '@/types/reminder.types'

const NOW = Date.now()
const DAY = 24 * 60 * 60 * 1000

function iso(offsetDays: number): string {
  return new Date(NOW + offsetDays * DAY).toISOString()
}

export const mockReminders: Reminder[] = [
  {
    id: 'rem-001',
    entityType: 'individual_customer',
    entityId: 'cust-001',
    title: 'Collect Form 16 for FY2024-25',
    description: 'Client to upload employer Form 16 before we start the filing.',
    reminderType: 'document_request',
    priority: 'high',
    dueDate: iso(3),
    status: 'pending',
    notifyChannels: ['in_app', 'email'],
    isOverdue: false,
    createdByName: 'Priya Sharma',
    createdAt: iso(-2),
    updatedAt: iso(-2),
  },
  {
    id: 'rem-002',
    entityType: 'individual_customer',
    entityId: 'cust-001',
    title: 'Advance tax 1st instalment',
    description: 'Remind client about the 15 June advance tax payment.',
    reminderType: 'payment_due',
    priority: 'urgent',
    dueDate: iso(-1),
    status: 'pending',
    notifyChannels: ['in_app', 'whatsapp'],
    isOverdue: true,
    createdByName: 'Priya Sharma',
    createdAt: iso(-10),
    updatedAt: iso(-10),
  },
  {
    id: 'rem-003',
    entityType: 'individual_customer',
    entityId: 'cust-001',
    title: 'Confirm bank details for refund',
    reminderType: 'follow_up',
    priority: 'medium',
    dueDate: iso(-5),
    status: 'completed',
    completedByName: 'Priya Sharma',
    completedAt: iso(-4),
    completionNotes: 'Verified primary HDFC account.',
    notifyChannels: ['in_app'],
    isOverdue: false,
    createdByName: 'Priya Sharma',
    createdAt: iso(-12),
    updatedAt: iso(-4),
  },
  {
    id: 'rem-004',
    entityType: 'individual_customer',
    entityId: 'cust-002',
    title: 'Schedule call to review capital gains',
    description: 'Discuss equity LTCG from the March sell-off.',
    reminderType: 'appointment',
    priority: 'medium',
    dueDate: iso(7),
    status: 'pending',
    notifyChannels: ['in_app', 'email'],
    isOverdue: false,
    createdByName: 'Amit Patel',
    createdAt: iso(-1),
    updatedAt: iso(-1),
  },
  {
    id: 'rem-005',
    entityType: 'individual_customer',
    entityId: 'cust-002',
    title: 'Request rent receipts for HRA',
    reminderType: 'document_request',
    priority: 'low',
    dueDate: iso(-3),
    status: 'pending',
    notifyChannels: ['in_app'],
    isOverdue: true,
    createdByName: 'Amit Patel',
    createdAt: iso(-8),
    updatedAt: iso(-8),
  },
  {
    id: 'rem-006',
    entityType: 'individual_customer',
    entityId: 'cust-003',
    title: 'ITR filing deadline reminder',
    description: 'Final reminder before the 31 July due date.',
    reminderType: 'filing_due',
    priority: 'high',
    dueDate: iso(14),
    status: 'pending',
    notifyChannels: ['in_app', 'email', 'whatsapp'],
    isOverdue: false,
    createdByName: 'Neha Gupta',
    createdAt: iso(-3),
    updatedAt: iso(-3),
  },
]
